import type * as React from 'react';
import { del } from '@Domain/Api';
import userRevoked, {
	type UserRevokedAction,
} from '@Application/Security/Authentications/Actions/userRevoked';
import parameters from '../../../parameters';

/**
 * The server call is best-effort: the route is `@Public()` and idempotent, so a failed server
 * revocation self-corrects at token expiry, while a UI that refuses to log out is a defect the
 * user suffers immediately and cannot work around. The local session is therefore always revoked.
 */
export default () => {
	return async (dispatch: React.Dispatch<UserRevokedAction>): Promise<UserRevokedAction> => {
		try {
			await del<void>(`${parameters.api.host}/api/token/refresh`);
		} catch {
			// Server-side revocation failure is intentionally ignored: the local session is
			// always cleared below, regardless of the outcome of this call.
		}

		const action = userRevoked();
		dispatch(action);
		return action;
	};
};
